import FileUpload from '../../components/FileUpload.mjs';
import PageShell from '../../components/PageShell.mjs';
import { useFileUpload } from '../hook/dataUploadHook.mjs';

const UploadPage = () => {
  const mieUpload = useFileUpload();
  const perDiemUpload = useFileUpload();

  const handlePTAEManagementClick = () => {
    window.location.href = '/ptae-management';
  };

  return (
    <PageShell title="Data Upload Center" width="5xl">
        <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 mb-4 sm:mb-6">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4">Upload Instructions</h2>
          <ol className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
            <li>Prepare your data files in CSV or Excel format according to the structure
              copied from the relevant sites</li>
            <li>Click "Choose File" to select the file from your computer.</li>
            <li>Click "Upload" to send the data to the server.</li>
            <li>Wait for confirmation that the upload was successful.</li>
          </ol>

          <p className="text-gray-600">For any issues with file formats or uploads, please contact the system administrator.</p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 mb-4 sm:mb-6">
          <p className="text-gray-700 mb-2">
            Mie Rate Breakdown: <a href="https://allowances.state.gov/content.asp?content_id=114&menu_id=78" target="_blank" rel="noopener noreferrer" className="text-stanford-red hover:text-stanford-light-red underline break-words">https://allowances.state.gov/content.asp?content_id=114&menu_id=78</a> for current breakdown for each rate.
          </p>
          <p className="text-gray-700">
            Country Data: <a href="https://allowances.state.gov/web920/per_diem_action.asp?MenuHide=1&CountryCode=0000" target="_blank" rel="noopener noreferrer" className="text-stanford-red hover:text-stanford-light-red underline break-words">https://allowances.state.gov/web920/per_diem_action.asp?MenuHide=1&CountryCode=0000</a>
          </p>
        </div>

        {/* PTAE Management Card */}
        <div className="mb-4 sm:mb-6">
          <div
            className="bg-white rounded-xl shadow-lg p-4 sm:p-6 cursor-pointer hover:shadow-xl transition-shadow border-l-4 border-stanford-red flex items-center gap-3 sm:gap-4"
            onClick={handlePTAEManagementClick}
          >
            <div className="text-stanford-red shrink-0">
              <svg className="w-10 h-10 sm:w-12 sm:h-12" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="currentColor"/>
                <path d="M17 12H15V10H17V12ZM17 16H15V14H17V16ZM13 8H7V10H13V8ZM13 12H7V14H13V12ZM13 16H7V18H13V16Z" fill="currentColor"/>
              </svg>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-semibold text-gray-800">PTAE Management</h3>
              <p className="text-gray-600 text-sm">Manage PTAE (Per Diem, Travel, and Administrative Expenses) codes and configurations</p>
            </div>
            <div className="text-gray-400 shrink-0">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z" fill="currentColor"/>
              </svg>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <FileUpload
              title="MIE Breakdown Upload"
              description="Upload CSV or Excel file with MIE (Meals and Incidental Expenses) breakdown data"
              acceptedFileTypes=".csv,.xlsx,.xls"
              fileName={mieUpload.fileName}
              isLoading={mieUpload.isLoading}
              uploadError={mieUpload.uploadError}
              uploadSuccess={mieUpload.uploadSuccess}
              uploadMessage={mieUpload.uploadMessage}
              onFileChange={mieUpload.handleFileChange}
              onClear={mieUpload.handleFileClear}
              onUpload={mieUpload.uploadMieBreakdown}
            />
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <FileUpload
              title="Per Diem Country Data Upload"
              description="Upload CSV or Excel file with per diem and MIE rates for different countries"
              acceptedFileTypes=".csv,.xlsx,.xls"
              fileName={perDiemUpload.fileName}
              isLoading={perDiemUpload.isLoading}
              uploadError={perDiemUpload.uploadError}
              uploadSuccess={perDiemUpload.uploadSuccess}
              uploadMessage={perDiemUpload.uploadMessage}
              onFileChange={perDiemUpload.handleFileChange}
              onClear={perDiemUpload.handleFileClear}
              onUpload={perDiemUpload.uploadPerDiemCountry}
            />
          </div>
        </div>
    </PageShell>
  );
};

export default UploadPage;
